import React from 'react'
import { PageBarFrame } from './PageBarFrame'
import { PageBarSubject } from './PageBarSubject'
import { PageBarSearch } from './PageBarSearch'

interface Props {
  subject: React.ReactNode
  /** Filled for the primary action, outlined for secondary, text for rare-and-destructive. */
  actions?: React.ReactNode
  search?: { value: string; onChange: (value: string) => void; placeholder?: string }
  /** The Filters control, when the page has anything to put behind it. */
  filters?: React.ReactNode
  /** Right-aligned count, e.g. "Showing 24 of 210 creatives". */
  status?: React.ReactNode
}

export const ListPageBar = ({ subject, actions, search, filters, status }: Props) => (
  <PageBarFrame>
    <PageBarSubject>{subject}</PageBarSubject>
    {search && <PageBarSearch {...search} />}
    {filters}
    {/* The action group wraps rather than holding its widest row: an unshrinkable
        row of buttons would set the whole page's minimum width and push a phone
        viewport into horizontal scrolling. */}
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    {status && <p className="ml-auto flex-shrink-0 text-sm text-mm-neutral-1-600">{status}</p>}
  </PageBarFrame>
)
